import { IFilterElement } from "@saleor/components/Filter";
import { findValueInEnum, maybe } from "@saleor/misc";
import {
  SearchPermissionGroups,
  SearchPermissionGroupsVariables
} from "@saleor/searches/types/SearchPermissionGroups";
import {
  StaffFilterKeys,
  StaffListFilterOpts
} from "@saleor/staff/components/StaffListPage";
import {
  LockStatus,
  MfaStatus,
  StaffUserInput
} from "@saleor/types/globalTypes";

import {
  createFilterTabUtils,
  createFilterUtils,
  dedupeFilter,
  getSingleEnumValueQueryParam
} from "../../../utils/filters";
import { InitialStaffFilterData_permissionGroups_edges_node } from "../../types/InitialStaffFilterData";
import {
  StaffListUrlFilters,
  StaffListUrlFiltersEnum,
  StaffListUrlQueryParams
} from "../../urls";
export const STAFF_FILTERS_KEY = "staffFilters";
import { UseSearchResult } from "@saleor/hooks/makeSearch";

import { getMultipleValueQueryParam } from "../../../utils/filters";
import { StaffListUrlFiltersWithMultipleValues } from "../../urls";
export function getFilterOpts(
  params: StaffListUrlFilters,
  groups: {
    initial: InitialStaffFilterData_permissionGroups_edges_node[];
    search: UseSearchResult<
      SearchPermissionGroups,
      SearchPermissionGroupsVariables
    >;
  }
): StaffListFilterOpts {
  return {
    groups: {
      active: !!params.groups,
      choices: maybe(
        () =>
          groups.search.result.data.search.edges.map(edge => ({
            label: edge.node.name,
            value: edge.node.id
          })),
        []
      ),
      displayValues: !!params.groups
        ? maybe(
            () =>
              groups.initial.map(permission => ({
                label: permission.name,
                value: permission.id
              })),
            []
          )
        : [],
      hasMore: maybe(
        () => groups.search.result.data.search.pageInfo.hasNextPage,
        false
      ),
      initialSearch: "",
      loading: groups.search.result.loading,
      onFetchMore: groups.search.loadMore,
      onSearchChange: groups.search.search,
      value: maybe(() => dedupeFilter(params.groups), [])
    },
    mfaStatus: {
      active: maybe(() => params.mfaStatus !== undefined, false),
      value: maybe(() => findValueInEnum(params.mfaStatus, MfaStatus))
    },
    status: {
      active: maybe(() => params.status !== undefined, false),
      value: maybe(() => findValueInEnum(params.status, LockStatus))
    }
  };
}

export function getFilterVariables(
  params: StaffListUrlFilters
): StaffUserInput {
  return {
    groups: params.groups,
    mfaStatus: params.mfaStatus
      ? findValueInEnum(params.mfaStatus, MfaStatus)
      : null,
    search: params.query,
    status: params.status ? findValueInEnum(params.status, LockStatus) : null
  };
}

export function getFilterQueryParam(
  filter: IFilterElement<StaffFilterKeys>,
  params: StaffListUrlFilters
): StaffListUrlFilters {
  const { active, group, name, value } = filter;

  if (!!group) {
    const rest = params && params[group] ? params[group] : undefined;

    return {
      [group]: active
        ? {
            ...(rest === undefined ? {} : rest),
            [name]: value
          }
        : rest
    };
  }

  switch (name) {
    case StaffFilterKeys.status:
      return getSingleEnumValueQueryParam(
        filter,
        StaffListUrlFiltersEnum.status,
        LockStatus
      );
    case StaffFilterKeys.groups:
      return getMultipleValueQueryParam(
        filter,
        StaffListUrlFiltersWithMultipleValues.groups
      );
    case StaffFilterKeys.mfaStatus:
      return getSingleEnumValueQueryParam(
        filter,
        StaffListUrlFiltersEnum.mfaStatus,
        MfaStatus
      );
  }
}

export const {
  deleteFilterTab,
  getFilterTabs,
  saveFilterTab
} = createFilterTabUtils<StaffListUrlFilters>(STAFF_FILTERS_KEY);

export const { areFiltersApplied, getActiveFilters } = createFilterUtils<
  StaffListUrlQueryParams,
  StaffListUrlFilters
>({
  ...StaffListUrlFiltersEnum,
  ...StaffListUrlFiltersWithMultipleValues
});
